import React from "react";

import { withStyles } from "@material-ui/core/styles";
import TextField from '@material-ui/core/TextField';
import FormControl from "@material-ui/core/FormControl";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormLabel from "@material-ui/core/FormLabel";
import FormHelperText from "@material-ui/core/FormHelperText";
import Checkbox from "@material-ui/core/Checkbox";
import FormGroup from "@material-ui/core/FormGroup";

import FormComponent from "../../classes/FormComponent";
import Form from "../../components/Form";
import EUI64Field from "../../components/EUI64Field";
import AutocompleteSelect from "../../components/AutocompleteSelect";
import DeviceProfileStore from "../../stores/DeviceProfileStore";


const styles = {
  formLabel: {
    fontSize: 12,
  },
};


class DeviceForm extends FormComponent {
  constructor() {
    super();
    this.getDeviceProfileOption = this.getDeviceProfileOption.bind(this);
    this.getDeviceProfileOptions = this.getDeviceProfileOptions.bind(this);
  }

  getDeviceProfileOption(id, callbackFunc) {
    DeviceProfileStore.get(id, resp => {
      callbackFunc({label: resp.deviceProfile.name, value: resp.deviceProfile.id});
    });
  }

  getDeviceProfileOptions(search, callbackFunc) {
    DeviceProfileStore.list(0, this.props.match.params.applicationID, 999, 0, resp => {
      const options = resp.result.map((dp, i) => {return {label: dp.name, value: dp.id}});
      callbackFunc(options);
    });
  }

  render() {
    if (this.state.object === undefined) {
      return(<div></div>);
    }

    return(
      <Form
        submitLabel={this.props.submitLabel}
        onSubmit={this.onSubmit}
        disabled={this.props.disabled}
      >
        <TextField
          id="name"
          label="设备名称"
          helperText="名称只能包含单词、数字和破折号。"
          margin="normal"
          value={this.state.object.name || ""}
          onChange={this.onChange}
          inputProps={{
            pattern: "[\\w-]+",
          }}
          fullWidth
          required
        />
        <TextField
          id="description"
          label="设备描述"
          margin="normal"
          value={this.state.object.description || ""}
          onChange={this.onChange}
          fullWidth
          required
        />
        {!this.props.update && <EUI64Field
          margin="normal"
          id="devEUI"
          label="devEUI"
          onChange={this.onChange}
          value={this.state.object.devEUI || ""}
          fullWidth
          required
          random
        />}
        <FormControl fullWidth margin="normal">
          <FormLabel className={this.props.classes.formLabel} required>Device-profile</FormLabel>
          <AutocompleteSelect
            id="deviceProfileID"
            label="设备能力"
            value={this.state.object.deviceProfileID}
            onChange={this.onChange}
            getOption={this.getDeviceProfileOption}
            getOptions={this.getDeviceProfileOptions}
          />
        </FormControl>
        <FormControl margin="normal">
          <FormGroup>
            <FormControlLabel
              label="禁用frame-counter验证"
              control={
                <Checkbox
                  id="skipFCntCheck"
                  checked={!!this.state.object.skipFCntCheck}
                  onChange={this.onChange}
                  color="primary"
                />
              }
            />
          </FormGroup>
          <FormHelperText>
            请注意，禁用帧计数器验证将危害安全性，因为它使人们能够执行重播攻击。
          </FormHelperText>
        </FormControl>
      </Form>
    );
  }
}

export default withStyles(styles)(DeviceForm);
